/* eslint-disable no-shadow */
export const discardedStages = {
  DISCARDED: 'discarded',
  DISCARDED_ALREADY_FILED: 'discarded_already_filed',
  DISCARDED_NOT_SUPPORTED: 'discarded_not_supported',
  DISCARDED_FREELANCER: 'discarded_freelancer',
  DISCARDED_NO_RESPONSE: 'discarded_no_response',
  DISCARDED_NOT_MANDATORY: 'discarded_not_mandatory',
  DISCARDED_NOT_WANT_TO_FILE: 'discarded_not_want_to_file',
  VALIDATION_REJECTED: 'validation_rejected',
  DISCARDED_OTHER: 'discarded_other',
};

export const previousYearsStage = {
  PREVIOUS_YEARS_NOT_REQUEST: 'not_request',
  PREVIOUS_YEARS_REQUEST: 'request',
};

export const afterFlowStages = {
  FILED_MANUAL: 'filed_manual',
  PENDING_AUTOMATIC_MODIFICATIONS: 'pending_automatic_modifications',
  PENDING_MANUAL_MODIFICATIONS: 'pending_manual_modifications',
  FINISHED: 'finished',
  FINISHED_NOT_SUCCESS: 'finished_not_success',
};

export const stages = {
  NOT_INITIALIZED: 'not_initialized',
  VALIDATING_CREDENTIALS: 'validating_credentials',
  VALIDATING_CREDENTIALS_ERROR: 'validating_credentials_error',
  DATA_RETRIEVAL: 'data_retrieval',
  DATA_PULLED: 'data_pulled',
  DATA_PARTIAL_PULLED: 'data_partial_pulled',
  DATA_PULLING: 'data_pulling',
  DATA_ERROR: 'error',
  MISSING_INFORMATION: 'missing_information',
  EXPIRED: 'expired',
  PERSONAL_DATA: 'personal_data',
  JOBS: 'jobs',
  INVESTMENTS: 'investments',
  DEDUCTIONS: 'deductions',
  RESULT: 'result',
  FILING: 'filing',
  SUBMITTED: 'submitted',
  FILED: 'filed',
  VALIDATION: 'validation',
  FINISHED_ACCEPTED: 'finished_accepted',
  FINISHED_SUCCESS: 'finished_success',
  FINISHED_MISSING_CLABE: 'finished_missing_clabe',
  VALIDATION_ACCEPTED: 'validation_accepted',
  FINISHED_PAYMENT_ISSUED: 'finished_payment_issued',
  FINISHED_TRANSFERRING: 'finished_transferring',
  TAX_AGENCY_DEBT: 'tax_agency_debt',
  TAX_AGENCY_CLABE_ISSUED: 'tax_agency_clabe_issued',
  FINISHED_AUTOMATIC_NOT_SUCCESS: 'finished_automatic_not_success',
  FINISHED_MANUAL_NOT_SUCCESS: 'finished_manual_not_success',
  SUBMITTED_CHANGED_WAITING_USER_RESPONSE: 'submitted_changed_waiting_user_response',
  SUBMITTED_CHANGED_PAUSED_REMINDERS: 'submitted_changed_paused_reminders',
  INVALID_SAT_CLABE: 'invalid_sat_clabe',
  AUTOMATIC_PAYMENT_FAILED: 'automaticPaymentFailed',
  ...discardedStages,
  ...afterFlowStages,
};

export const stagesLabels = {
  [stages.DATA_RETRIEVAL]: 'TaxScreen.Initial.title',
  [stages.DISCARDED]: 'Dashboard.discarded.message',
  [stages.MISSING_INFORMATION]: 'TaxScreen.InProgress.missing_information',
  [stages.DISCARDED_ALREADY_FILED]: 'Dashboard.discarded_already_filed.message',
  [stages.DISCARDED_FREELANCER]: 'Dashboard.discarded_freelancer.message',
  [stages.DISCARDED_NO_RESPONSE]: 'Dashboard.discarded_no_response.message',
  [stages.DISCARDED_NOT_MANDATORY]: 'Dashboard.discarded_not_mandatory.message',
  [stages.DISCARDED_NOT_WANT_TO_FILE]: 'Dashboard.discarded_not_want_to_file.message',
  [stages.VALIDATION_REJECTED]: 'Dashboard.discarded_not_want_to_file.message',
  [stages.DISCARDED_OTHER]: 'Dashboard.discarded_other.message',
  [stages.DISCARDED_NOT_SUPPORTED]: 'Dashboard.discarded_not_supported.message',
  [stages.DATA_ERROR]: 'TaxScreen.Initial.title',
  [stages.DATA_PARTIAL_PULLED]: 'TaxScreen.Initial.title',
  [stages.DEDUCTIONS]: 'TaxScreen.InProgress.deductions',
  [stages.PERSONAL_DATA]: 'TaxScreen.InProgress.personal_data',
  [stages.JOBS]: 'TaxScreen.InProgress.jobs',
  [stages.INVESTMENTS]: 'TaxScreen.InProgress.investments',
  [stages.RESULT]: 'TaxScreen.InProgress.result',
  [stages.SUBMITTED]: 'Dashboard.Submitted.message',
  [stages.FILED]: 'Dashboard.Filed.message',
  [stages.VALIDATION]: 'Dashboard.Validation.message',
  [stages.FILED_MANUAL]: 'TaxScreen.filed_manual.title',
  [stages.FINISHED]: 'TaxScreen.finished.title',
  [stages.FINISHED_NOT_SUCCESS]: 'TaxScreen.finished_not_success.title',
  [stages.PENDING_AUTOMATIC_MODIFICATIONS]: 'TaxScreen.pending_automatic_modifications.title',
  [stages.PENDING_MANUAL_MODIFICATIONS]: 'TaxScreen.pending_manual_modifications.title',
  [stages.FINISHED_ACCEPTED]: 'Dashboard.Accepted.message',
  [stages.FINISHED_SUCCESS]: 'Dashboard.Paid.message',
  [stages.FINISHED_MISSING_CLABE]: 'Dashboard.missing_clabe.message',
  [stages.VALIDATION_ACCEPTED]: 'Dashboard.Submitted.message',
  [stages.FINISHED_PAYMENT_ISSUED]: 'Dashboard.SendDevolution.message',
  [stages.FINISHED_TRANSFERRING]: 'Dashboard.ProcessPayment.message',
  [stages.TAX_AGENCY_DEBT]: 'Dashboard.FiscalCredit.message',
  [stages.TAX_AGENCY_CLABE_ISSUED]: 'Dashboard.ClabeIssue.message',
  [stages.FINISHED_AUTOMATIC_NOT_SUCCESS]: 'TaxScreen.finished_automatic_not_success.title',
  [stages.FINISHED_MANUAL_NOT_SUCCESS]: 'TaxScreen.finished_manual_not_success.title',
};

export const discardedStagesToRedirectLink = [
  discardedStages.DISCARDED_NOT_MANDATORY.toLowerCase(),
  discardedStages.DISCARDED_OTHER.toLowerCase(),
  discardedStages.DISCARDED_NOT_SUPPORTED.toLowerCase(),
];

export const discardedStageContact = [
  discardedStages.DISCARDED_NOT_WANT_TO_FILE.toLowerCase(),
  discardedStages.DISCARDED_NO_RESPONSE.toLowerCase(),
  discardedStages.DISCARDED_ALREADY_FILED.toLowerCase(),
  discardedStages.VALIDATION_REJECTED.toLocaleLowerCase(),
];

export const discardedStageMsg = [
  discardedStages.DISCARDED_NOT_WANT_TO_FILE.toLowerCase(),
  discardedStages.DISCARDED_NO_RESPONSE.toLowerCase(),
  discardedStages.DISCARDED_NOT_MANDATORY.toLowerCase(),
];

export const notFlowStages = {
  NOT_INITIALIZED: 'not_initialized',
  VALIDATING_CREDENTIALS: 'validating_credentials',
  VALIDATING_CREDENTIALS_ERROR: 'validating_credentials_error',
  DATA_RETRIEVAL: 'data_retrieval',
  DATA_PULLED: 'data_pulled',
  DATA_PARTIAL_PULLED: 'data_partial_pulled',
  DATA_PULLING: 'data_pulling',
  DATA_ERROR: 'error',
};

export const stagesToWizard = [
  stages.VALIDATION,
  stages.VALIDATION_ACCEPTED,
  stages.PENDING_AUTOMATIC_MODIFICATIONS,
  stages.TAX_AGENCY_DEBT,
  stages.TAX_AGENCY_CLABE_ISSUED,
  stages.FINISHED_NOT_SUCCESS,
  stages.FINISHED_SUCCESS,
  stages.FINISHED_ACCEPTED,
  stages.FILED,
  stages.FINISHED_MISSING_CLABE,
  stages.FINISHED_TRANSFERRING,
  stages.SUBMITTED,
  stages.FINISHED_AUTOMATIC_NOT_SUCCESS,
  stages.FINISHED_PAYMENT_ISSUED,
];

export enum DomiciliationStatus {
  NO_ACTION_NEEDED = 'noActionNeeded',
  PENDING_MANUAL_PAYMENT = 'pendingManualPayment',
  PROCESSING_AUTOMATIC_PAYMENT = 'processingAutomaticPayment',
  AUTOMATIC_PAYMENT_FAILED = 'automaticPaymentFailed',
  PAYMENT_NOT_INITIATED = 'paymentNotInitiated',
}
